export const INITIATE_OMS_LOOKUP = 'INITIATE_OMS_LOOKUP';
export const OMS_LOOKUP_SUCCESS = 'OMS_LOOKUP_SUCCESS';
export const OMS_LOOKUP_FAILURE = 'OMS_LOOKUP_FAILURE';
export const OMS_IS_AUTHENTICATING = 'OMS_IS_AUTHENTICATING';
export const SET_CREDENTIALS = 'SET_CREDENTIALS';
import { error as notificationError } from 'react-notification-system-redux';
import store from '@src/store';
import { CustomResponse } from 'gc-backend';
import { AUTO_COFE_SAVE_START } from '@src/app/accounts/summary/actions';
import { REFETCH_CUSTOMER_DATA } from '../weak/actions';
import { NONAME } from 'dns';

const notificationOMSLookupError = {
  title: 'Account Lookup Error',
  message: 'Sorry, we could not find your account',
  position: 'bl',
  autoDismiss: 0,
};
export type Actions = {
  INITIATE_OMS_LOOKUP: { type: typeof INITIATE_OMS_LOOKUP; payload: any };
  SET_CREDENTIALS: { type: typeof SET_CREDENTIALS; payload: any };
  OMS_LOOKUP_SUCCESS: {
    type: typeof OMS_LOOKUP_SUCCESS;
    payload: CustomResponse;
  };
  OMS_LOOKUP_FAILURE: {
    type: typeof OMS_LOOKUP_FAILURE;
    payload: any | string[];
  };
  OMS_IS_AUTHENTICATING: {
    type: typeof OMS_IS_AUTHENTICATING;
    payload: boolean;
  };
};

export const actionCreators = {
  initiateOmsLookup: (
    accountNumber: string,
    postalCode: string,
    token: string,
    idProvider: string,
    productExcludes: any,
    resinAccounts: any,
    idpAccountInfo: any,
  ): Actions[typeof INITIATE_OMS_LOOKUP] => ({
    type: INITIATE_OMS_LOOKUP,
    payload: {
      accountNumber: accountNumber,
      postalCode: postalCode,
      token: token,
      provider: idProvider,
      productExcludes: productExcludes,
      resinAccounts: resinAccounts,
      idpAccountInfo: idpAccountInfo,
    },
  }),
  omsLookupSuccess: (
    gcResponse: CustomResponse,
    ): Actions[typeof OMS_LOOKUP_SUCCESS] => ({
      type: OMS_LOOKUP_SUCCESS, 
      payload: gcResponse 
  }),
  omsLookupFailure: (error: any): Actions[typeof OMS_LOOKUP_FAILURE] => ({
    type: OMS_LOOKUP_FAILURE,
    payload: error,
  }),
  omsLookupFailureNotification: (message?: any): void => {
    let messageObject = message
      ? { ...notificationOMSLookupError, message }
      : notificationOMSLookupError;
    store.dispatch(notificationError(messageObject));
  },
  omsLookupClearNotifications: (): void => {
    store.dispatch(notificationError(notificationOMSLookupError));
  },
  omsSetCredentials: (credentials: any): Actions[typeof SET_CREDENTIALS] => ({
    type: SET_CREDENTIALS,
    payload: credentials,
  }),
  setAuthenticating: (
    payload: boolean,
  ): Actions[typeof OMS_IS_AUTHENTICATING] => ({
    type: OMS_IS_AUTHENTICATING,
    payload,
  }),
};
